<template>
  <div>
    <div class="row">
      <div class="col-8">
        <form action="" class="md-layout" @submit.prevent="submit">
          <div class="md-layout-item">
            <md-card-header>
              <div class="md-title">
                {{ editando ? 'Editar' : 'Cadastrar' }} Usuário
              </div>
            </md-card-header>
            <md-card-content>
              <md-field :class="getValidationClass('username')">
                <label for="nome">Nome do usuário</label>
                <md-input id="nome" v-model="form.username" />
                <span v-if="!$v.form.username.alpha" class="md-error"
                  >Somente letras</span
                >
                <span v-if="!$v.form.username.required" class="md-error"
                  >Nome é obrigatório</span
                >
              </md-field>
              <md-field :class="getValidationClass('nomeCompleto')">
                <label for="nomeCompleto">Nome Completo</label>
                <md-input id="nomeCompleto" v-model="form.nomeCompleto" />
                <span v-if="!$v.form.nomeCompleto.invalid" class="md-error"
                  >Nome completo é obrigatório</span
                >
              </md-field>
              <md-field v-if="!editando" :class="getValidationClass('email')">
                <label for="email">E-mail</label>
                <md-input id="email" v-model="form.email" type="email" />
                <span v-if="!$v.form.email.invalid" class="md-error"
                  >E-mail é obrigatório</span
                >
              </md-field>
              <md-field :class="getValidationClass('roles')">
                <label for="role">Nível de acesso</label>
                <md-select id="role" v-model="form.roles" multiple>
                  <md-option
                    v-for="role in roles"
                    :key="role.id"
                    :value="role.name"
                  >
                    {{ roleToText(role.name) }}
                  </md-option>
                </md-select>
                <span v-if="!$v.form.roles.invalid" class="md-error"
                  >Nível de acesso é obrigatório</span
                >
              </md-field>
              <div v-if="!editando" class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field
                    :md-toggle-password="false"
                    :class="getValidationClass('password')"
                  >
                    <label for="senha">Senha</label>
                    <md-input
                      id="senha"
                      v-model="form.password"
                      type="password"
                      name="senha"
                    />
                    <span v-if="!$v.form.password.required" class="md-error"
                      >Senha é obrigatória</span
                    >
                    <span v-if="!$v.form.password.minLength" class="md-error"
                      >Tamanho minimo é de 6 caracteres</span
                    >
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-field
                    :md-toggle-password="false"
                    :class="getValidationClass('confirmPassword')"
                  >
                    <label for="senhaConfirm">Confirmação</label>
                    <md-input
                      id="senhaConfirm"
                      v-model="form.confirmPassword"
                      type="password"
                      name="senhaConfirm"
                    />
                    <span
                      v-if="!$v.form.confirmPassword.sameAsPassword"
                      class="md-error"
                      >Senhas devem ser identicas</span
                    >
                    <span
                      v-else-if="!$v.form.confirmPassword.required"
                      class="md-error"
                      >Confirmação é obrigatória</span
                    >
                  </md-field>
                </div>
              </div>
              <div class="botoes">
                <md-button
                  class="md-raised md-accent"
                  @click.prevent="$router.replace('/usuarios')"
                >
                  Voltar
                </md-button>
                <md-button type="submit" class="md-raised md-primary">
                  Salvar
                </md-button>
              </div>
            </md-card-content>
          </div>
        </form>
      </div>
      <div class="col-4">
        <md-card class="md-layout-item">
          <md-card-header>
            <div class="md-title">Locais</div>
          </md-card-header>
          <md-card-content>
            <md-field>
              <label for="search">Busca de locais</label>
              <md-input
                id="search"
                v-model="locaisSearch"
                @input="searchLocais(locaisSearch)"
              />
            </md-field>
            <div v-if="locaisSearch !== ''">
              <md-checkbox
                v-for="local in locaisSearchResult"
                :key="local.id"
                v-model="locaisSelected"
                :value="local.id"
              >
                {{ local.nome }}
              </md-checkbox>
            </div>
            <div v-else>
              <md-checkbox
                v-for="local in locais"
                :key="local.id"
                v-model="locaisSelected"
                :value="local.id"
              >
                {{ local.nome }}
              </md-checkbox>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { alpha, minLength, required, sameAs } from 'vuelidate/lib/validators'

import { roleToText } from '@/utils/auth'

import http from '../../utils/http'

export default {
  name: 'UsuarioEditar',
  mixins: [validationMixin],
  data() {
    return {
      form: {
        userId: null,
        username: '',
        nomeCompleto: '',
        email: '',
        roles: [],
        password: '',
        confirmPassword: '',
      },
      roles: [],
      locaisSelected: [],
      locaisSearch: '',
      locaisSearchResult: [],
      locais: [],
      editando: null,
    }
  },
  validations: {
    form: {
      username: { required, alpha },
      nomeCompleto: { required },
      email: { required },
      roles: { required },
      password: {
        minLength: minLength(6),
        required,
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
  },
  mounted() {
    this.fetchRoles()
    this.fetchLocais()
    this.editando =
      this.$route.params.userId !== undefined &&
      this.$route.params.userId !== null
    if (this.editando) {
      this.fetchUsuario()
    }
  },
  methods: {
    roleToText,
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    async fetchRoles() {
      this.roles = await http.get('accounts/roles')
    },
    async fetchLocais() {
      this.locais = (await http.get('local')).locais
    },
    async fetchUsuario() {
      const usuario = await http.get(
        `accounts/user/${this.$route.params.userId}`
      )
      this.form.userId = this.$route.params.userId
      this.form.username = usuario.userName
      this.form.nomeCompleto = usuario.nomeCompleto
      this.form.roles = usuario.roles
      this.locaisSelected = usuario.userLocais
    },
    searchLocais(query) {
      this.locaisSearchResult = []
      if (query !== '') {
        this.locais.forEach((element) => {
          if (element.nome.toLocaleLowerCase().indexOf(query) !== -1) {
            this.locaisSearchResult.push(element)
          }
        })
      }
    },
    async submit() {
      this.$v.$touch()

      let result = null

      if (this.editando) {
        if (this.$v.form.username.$invalid || this.$v.form.roles.$invalid) {
          return
        }

        result = await http.put('accounts', {
          ...this.form,
          locais: this.locaisSelected,
        })
      } else {
        // Validacao para todos
        if (this.$v.$invalid) {
          return
        }

        result = await http.post('accounts', {
          ...this.form,
          locais: this.locaisSelected,
        })
      }

      if (result != null) {
        await this.$router.replace('/usuarios')
      }
    },
  },
}
</script>

<style scoped>
div > .md-card {
  height: 100%;
  overflow: auto;
  max-height: 90vh;
}

form {
  height: 90vh;
}

.botoes {
  float: right;
}
</style>
